import React, { useLayoutEffect } from 'react';
import styled from '@emotion/styled';
import Column from '@amzn/meridian/column';
import CarrierLogisticsLogo from '../images/cl-logo.svg';
import MainLogo from '../images/splashscreen-logo.png';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
`;

const OverlayBackground = styled(Wrapper)`
  position: fixed;
  overflow: hidden;
  background: white;
  z-index: 26;
`;

const Image = styled.img`
  width: 16.25rem;
  height: auto;
  z-index: 1;
`;

const RelativeBox = styled.div`
  position: relative;
  height: 40px;
`;

const TypeWriterEffect = styled.div`
  z-index: 2;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  overflow: hidden;
  background: white;
  transform: scale(1.3);
  animation: typing 1s steps(40, end);
  animation-iteration-count: 1;
  @keyframes typing {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;

const Logo = styled.div`
  margin: 0 auto;
  width: 16.25rem;
  height: 16.25rem;
  background: #232f3e;
  position: relative;
  border-radius: 50px;

  animation: opacity-in 1.5s;
  animation-iteration-count: 1;

  @keyframes opacity-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const ScaledColumn = styled(Column)`
  transform: scale(0.5);
  -moz-transform: scale(0.5);
`;

const SplashScreen = () => {
  useLayoutEffect(() => {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.height = 'auto';
      document.body.style.overflow = 'auto';
    };
  });

  return (
    <OverlayBackground absolute>
      <ScaledColumn spacing="small">
        <Logo>
          <Image src={MainLogo} />
        </Logo>
        <RelativeBox>
          <TypeWriterEffect>
            <Image src={CarrierLogisticsLogo} />
          </TypeWriterEffect>
        </RelativeBox>
      </ScaledColumn>
    </OverlayBackground>
  );
};

export default SplashScreen;
